import React, { useEffect } from 'react'
import { callTeamTodayReport, extractTeamAgent, calcHierarchyEle, buildHierarchy, sumHierarchy, calcHierarchy } from '../../../services/reports/TeamTodayReportService'
import { resetWindow } from '../../../services/UtilService'


import './TeamTodayReport.css'
import TeamTodayReportComponent from './TeamTodayReportComponent'

export default (props) => {
    useEffect(() => {
        resetWindow()
    }, [])

    return <React.Fragment>
        <TeamTodayReportComponent
            type={props.type}
            buildHierarchy={buildHierarchy}
            sumHierarchy={sumHierarchy}
            calcHierarchy={calcHierarchy}
            extractTeam={extractTeamAgent}
            calcHierarchyEle={calcHierarchyEle}
            callTeamReport={callTeamTodayReport}>
        </TeamTodayReportComponent>
    </React.Fragment>
}
